<template>

    <div>
        <div v-if="errors">
            {{ errors }}
        </div>

        <div class="entries-table-wrap">
            <table id="sortable-table" class="nice-table"">
                <thead>

                <tr class="tableHeaderRow">
                    <th style="width: 145px;" class="th-entry pl-2" v-on:click="setSort('entry_id')">Entry # <i class="fa cursor-pointer" :class="((sort_order != 'desc') && (sort == 'entry_id')) ? 'fa-caret-up' : 'fa-caret-down'"></i></th>
                    <th class="th-title" v-on:click="setSort('title')">Title <i class="fa cursor-pointer" :class="((sort_order != 'desc') && (sort == 'title')) ? 'fa-caret-up' : 'fa-caret-down'"></i></th>
                    <th style="width: 235px;" class="th-category" v-on:click="setSort('category.name')">Category <i class="fa cursor-pointer" :class="((sort_order != 'desc') && (sort == 'category')) ? 'fa-caret-up' : 'fa-caret-down'"></i></th>
                    <th class="th-name" v-on:click="setSort('first_entrant_name')">Name <i class="fa cursor-pointer" :class="((sort_order != 'desc') && (sort == 'first_entrant_name')) ? 'fa-caret-up' : 'fa-caret-down'"></i></th>
                    <th style="width: 130px;" class="th-status" v-on:click="setSort('entry_status')">
                        Status <i class="fa cursor-pointer" :class="((sort_order != 'desc') && (sort == 'entry_status')) ? 'fa-caret-up' : 'fa-caret-down'"></i></th>
                </tr>
                </thead>
                <tbody v-for="(entry,i) in entries.data" >
                <tr @click="loadEntry(entry.entry_id)">
                    <td  class="pl-2"><div>{{ entry.entry_id }}</div></td>
                    <td><div>{{ entry.title }}</div></td>
                    <td><div>{{ entry.category.name }}</div></td>
                    <td><div v-for="entrant in entry.entrants">{{ entrant.first_name }} {{ entrant.last_name }}</div></td>
                    <td class="status">
                        <div class="">
                            {{ orderStatusHumanReadable(entry.entry_status) }}
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div style="float:right;">
            <pagination :data="entries" @pagination-change-page="paginationCalculator" :limit="3">
                <span slot="prev-nav">&lt; Previous</span>
                <span slot="next-nav">Next &gt;</span>
            </pagination>
        </div>
        <div class="dataTables_info" v-if="to">Showing 1-{{to}} of {{ total }} entries</div>
        <div class="dataTables_info" v-else>Showing 0 entries</div>
        <div class="dataTables_length admin-entry-table">
            <label>
                <span>Show</span>
                <select class="plain-select num-entries-select" v-model="num">
                    <option value="10">10 Entries</option>
                    <option value="20">20 Entries</option>
                    <option value="50">50 Entries</option>
                    <option value="100">100 Entries</option>
                </select>
                <span>per page</span>
            </label>
        </div>

    </div>
</template>

<script>
    export default {
        name: "EntriesTable",
        props: {
          fetchUrl: String
        },
        data() {
            return {
              errors: false,
              num: 20,
              page: 1,
              total: 0,
              to: 0,
              sort: '',
              sort_order: 'desc',
              entries: {},
              query_keyword: (localStorage.getItem('CTA-history-search') != null) ? localStorage.getItem('CTA-history-search') : '',
              query_entry_status: '',
              entry_status_options: [{
                text: "In Progress",
                id: "in_progress"
              }, {
                text: "Under Faculty Review",
                id: "under_faculty_review"
              }, {
                text: "Canceled",
                id: "canceled"
              }, {
                text: "Need More Information",
                id: "need_more_info"
              }, {
                text: "Complete",
                id: "faculty_approved"
              }, {
                text: "Complete",
                id: "ready_for_ballot"
              }]
            }
        },
        mounted() {
            if(localStorage.getItem('CTA-history-search-sort')) {
                this.sort = localStorage.getItem('CTA-history-search-sort');
            }
            if(localStorage.getItem('CTA-history-search-sort-order')) {
                this.sort_order = localStorage.getItem('CTA-history-search-sort-order');
            }
            if(localStorage.getItem('CTA-history-search-num')) {
                this.num = localStorage.getItem('CTA-history-search-num');
            }
            if(localStorage.getItem('CTA-history-search-page')) {
                this.page = localStorage.getItem('CTA-history-search-page');
            }
            if(localStorage.getItem('CTA-history-search-status')) {
                var searchStatus = localStorage.getItem('CTA-history-search-status');
                this.query_entry_status = searchStatus.split(',');
            }
            this.fetchEntries(this.page);
        },
        methods:{
          orderStatusHumanReadable(inputStatus) {

            switch(inputStatus) {
              case 'in_progress':
                return 'In Progress';
              case 'under_faculty_review':
                return 'Under Faculty Review';
              case 'faculty_approved':
                return 'Complete';
              case 'need_more_info':
                return 'Need More Info';
              case 'ready_for_ballot':
                return 'Complete';
              default:
                return inputStatus;
            }
          },
          loadEntry(entry_id){
                window.location = '/entry/'+entry_id;
            },
            fetchEntries(page = 1){
                let app = this;
                axios.get(app.fetchUrl, {
                    params: {
                        num: app.num,
                        page: page,
                        sort: app.sort,
                        sort_order: app.sort_order,
                        keyword: app.query_keyword,
                        entry_status: app.query_entry_status,
                        }
                    })
                    .then(res => {
                        app.entries = res.data;
                        app.total = res.data.total;
                        app.to = res.data.to;
                        localStorage.setItem('CTA-history-search-to', app.to);
                        localStorage.setItem('CTA-history-search', app.query_keyword);
                        localStorage.setItem('CTA-history-search-status', app.query_entry_status);
                        localStorage.setItem('CTA-history-search-num', app.num);
                    }).catch(err => {
                  let errorMessage = err.response.status + ' status error. There was a problem uploading your file.';
                  app.$parent.$refs.flash_alert.activateFlashAlert(errorMessage, 'error');
                 });
            },
            setSort(sort) {
                if (this.sort == sort) {
                    this.sort_order = (this.sort_order == 'desc')?'asc':'desc';
                } else {
                    this.sort = sort;
                    this.sort_order = 'desc';
                }
                localStorage.setItem('CTA-history-search-sort', this.sort);
                localStorage.setItem('CTA-history-search-sort-order', this.sort_order);
                this.fetchEntries();
            },
            openAssignModal(i){
                this.assigned_invoice = this.invoices[i];
                this.check_assign_amount = this.assigned_invoice.amount_due.toFixed(2);
                this.assignCheckModal = true;
            },
            paginationCalculator: function(pageIndex) {
                localStorage.setItem('CTA-history-search-page', pageIndex);
                this.fetchEntries(pageIndex);
            }
        },
        watch: {
            query_keyword() {
                // clear the pagination when the keyword is changing
                localStorage.removeItem('CTA-history-search-page');
                this.fetchEntries(this.page);
                },
            query_entry_status() {
                localStorage.removeItem('CTA-history-search-page');
                this.fetchEntries(this.page);
                },
            num() {
                this.page = 1;  // Reset to first page when number of items changed
                this.fetchEntries(this.page);
                },
        }
    }
</script>
